<template>
  <el-container style="height: 100vh;">
    <el-aside width="256px">
      <asides :id="id"></asides>
    </el-aside>
    <el-container>
      <el-header height="90px" style="border-bottom:1px solid #979797;">
        <headers></headers>
      </el-header>
      <el-main style="background: #f9f9f9;" class="pt30">
        <router-view class="h100" />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import asides from '@/components/asides';
import headers from '@/components/headers';
import store from 'store';

export default {
  components: {
    asides,
    headers,
  },
  computed: {},
  props: ['id'],
  data() {
    return {};
  },
  mounted() {
    this.isCallAccount();
  },

  methods: {
    async getAccountInfo() {
      let res = await this.$http.get(`/api/official-account/${this.id}`);
      if (res) {
        store.set('oaNickName', res.nickName);
        store.set('officialID', this.id);
      }
    },
    isCallAccount() {
      let id = store.get('officialID'),
        nickName = store.get('oaNickName');

      if (id != this.id || !nickName) {
        this.getAccountInfo();
      }
    },
  },
};
</script>
